export default {"src":"/_next/static/media/grid-dark.c14a90c2.svg","height":59,"width":181,"blurWidth":0,"blurHeight":0};